// import {
//   getJsSDKConfigApi
// } from "@/api/wechat";
import {
  useWxSDK
} from "./useWxSDK.js";

const { initConfig, setShareInfo } = useWxSDK();

export function useWxShare (res, dataList) {
  initConfig(res, dataList)
}